export class MessageDialogBox{
    enable:boolean;
    title:string;
    message:string;
}